/**
 * @export
 * @class ProductInfoNotes
 * 상품정보제공고시
 */
export default class ProductInfoNotes {
  constructor() {
    // 필요 data 유효 확인
    const {
      contentInfo = {},
    } = TMON.oApp.htStorage.htStaticData.htDealContentInfo;
    if (!contentInfo && Object.keys(contentInfo).length < 1) return;

    this.productInfoNoteObj = contentInfo.productInfoNote
      ? JSON.parse(contentInfo.productInfoNote)
      : false;

    if (
      !this.productInfoNoteObj ||
      !this.productInfoNoteObj.kft ||
      this.productInfoNoteObj.kft.length < 1
    ) {
      return;
    }

    this.welWrapper = $('#_wrapProductInfoNotes');
    this.isRendered = false;

    this.init();
    this.setEvent();
  }

  init() {
    for (let i = 0; i < this.productInfoNoteObj.kft.length; i += 1) {
      this.welWrapper.append(
        `<div class="bx_ct">
                    <div class="ct_wrp">
                        <button type="button" data-role="toggleButton" class="toggle tit_align_top">
                            <h4>상품정보제공고시</h4>
                        </button>
                        <div class="ct slide-ct">
                            <table class="tbl_info" cellSpacing="0">
                                <colgroup><col style="width: 35%"></col></colgroup>
                                <tbody data-key=${i}></tbody>
                            </table>
                        </div>
                    </div>
                </div>`
      );
    }

    if (TMON.oApp.sPlatform === 'PW') {
      this.render();
    }
  }

  render() {
    // [SDLUI-2081] 상품정보제공고시 내 글자수가 많을 경우 꺼지는 현상 수정
    // [SDLUI-2377] [딜상세] 모바일 상품정보고시 초기 랜더링 개선
    // 안드로이드에서 멈춤 및 현상으로 모바일에서 토글시 랜더링하도록 개선
    for (let i = 0; i < this.productInfoNoteObj.kft.length; i += 1) {
      const keys = Object.keys(this.productInfoNoteObj.kft[i].items);
      const welTBody = this.welWrapper.find(`.bx_ct tbody[data-key=${i}]`);

      for (let j = 0; j < keys.length; j += 1) {
        const key = keys[j];
        const content = this.productInfoNoteObj.kft[i].items[key];
        welTBody.append(
          `<tr>
                        <th scope="row">${key}</th>
                        <td data-key=${j}></td>
                    </tr>`
        );
        const welTd = this.welWrapper.find(
          `.bx_ct tbody[data-key=${i}] tr td[data-key=${j}]`
        );

        // 글자수가 30000이 넘을 경우 잘라서 append한다.
        if (content.length <= 30000) {
          welTd.append(content);
        } else {
          const sliceLength = content.length / 30000 + 1;

          for (let k = 0; k < sliceLength; k += 1) {
            const slicedContent = content.slice(k * 30000, 30000 * (k + 1));
            if (slicedContent) {
              welTd.append(slicedContent);
            }
          }
        }
      }
    }

    this.isRendered = true;
  }

  setEvent() {
    // toggle eventListener 등록
    this.welWrapper.on('click', '[data-role=toggleButton]', this.onClickToggle);
    // 앱에서 링크 이동 eventListener 등록
    if (TMON.view_mode === 'app') {
      this.welWrapper.on('click', 'a', this.onClickLink);
    }
  }

  clearEvent() {
    if (this.welWrapper) {
      this.welWrapper.off('click', '[data-role=toggleButton]');
      if (TMON.view_mode === 'app') {
        this.welWrapper.off('click', 'a');
      }
    }
  }

  /**
   * toggle eventListener
   */
  onClickToggle = e => {
    $(e.currentTarget).toggleClass('open');

    if (TMON.oApp.sPlatform !== 'PW' && !this.isRendered) {
      this.render();
    }
  };

  /**
   * 앱에서 링크 이동 eventListener
   */
  onClickLink = e => {
    TMON.app.callApp(
      'webview',
      'showNaviWebView',
      '티몬',
      TMON.util.aup($(e.currentTarget).attr('href'), TMON.sAppQuery),
      false,
      false,
      true
    );

    e.preventDefault();
  };
}
